import React, { FC } from 'react';
import { Field } from '../components/Field';
import { useAuthentication } from '../containers/AuthProvider';
import { doLogin } from '../api/requests';

export const LoginPage: FC = () => {
  const { setUser } = useAuthentication();
  const emailRef = React.useRef<any>();
  const passwordRef = React.useRef<any>();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    try {
      const newUser = await doLogin(email, password);
      setUser(newUser);
    } catch (e) {
      console.error(e);
    }
  };

  return <div>
    <form onSubmit={handleSubmit}>
      <Field ref={emailRef} label="Email" type="email"/>
      <Field ref={passwordRef} label="Password" type="password"/>
      <div>
        <button type="submit">Login</button>
      </div>
    </form>
  </div>;
};
